import { useContext } from 'react'
import { useNls } from '../../nls/nlsProvider'
import { ItemTimeContext, ItemTimeProvider, useItemTime } from './ItemTimeProvider'
import { formatItemTimeLoggedAndEstimate } from './itemTimeFormat'
import './timesheets.css'

export interface ItemTimeDisplayProps {
  workspaceId?: string
  nodeId?: string | null
  estimatedHours?: number | null
  actualMinutes?: number | null
  className?: string
  testId?: string
}

export const ItemTimeDisplay = (props: ItemTimeDisplayProps) => {
  const context = useContext(ItemTimeContext)
  if (!context) {
    return (
      <ItemTimeProvider workspaceId={props.workspaceId}>
        <ItemTimeDisplayContent {...props} />
      </ItemTimeProvider>
    )
  }
  return <ItemTimeDisplayContent {...props} />
}

const ItemTimeDisplayContent = ({
  nodeId,
  estimatedHours,
  actualMinutes,
  className = '',
  testId = 'item-time-logged-estimate',
}: ItemTimeDisplayProps) => {
  const context = useContext(ItemTimeContext)
  const { t } = useNls()
  const { minutes } = useItemTime(nodeId)

  if (!context?.isEnabled || !nodeId || nodeId.startsWith('draft-')) {
    return null
  }

  const { text, tone, className: formatClassName } = formatItemTimeLoggedAndEstimate({
    loggedMinutes: minutes,
    estimatedHours,
    actualMinutes,
    t,
  })

  return (
    <div
      className={`${formatClassName} ${className}`.trim()}
      data-testid={testId}
      data-tone={tone}
      aria-label={text}
    >
      {text}
    </div>
  )
}
